import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal";
import api from '../../../services/axios';
import Swal from "sweetalert2";

const EditLink = ({ name, id, type, isOpen, linkname, closeCallback, successCallback }) => {
    const [linkvalue, setLinkValue] = useState(linkname);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);


    const handleLinkChange = (e) => {
        setLinkValue(e.target.value);
    }

    useEffect(() => {
        setLinkValue(linkname);
    }, [linkname], );

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubBtnDisabled(true);

        if (linkvalue === '') {

            Swal.fire({
                position: "center",
                icon: "info",
                text: 'Link is required',
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
            setSubBtnDisabled(false);
            setLinkValue('');
            return;
        }


        try {
            let body = {
                linkname: linkvalue,
                linkidentifier: id
            };
            let endpoint = "Link/Edit";
            const { data } = await api.put(endpoint, body);
            if (data.statusCode === 200) {
                if (successCallback)
                    successCallback(id);
                closeCallback();
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: 'Successfully edited the Link',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                });
                setSubBtnDisabled(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLinkValue('');
    }
    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title">
                    <img src="/Assets/link.svg" alt="Add Files" /> Edit {type}
                </h5>
            </ModalHeader>
            <ModalBody>
                <label className="folder-btm-text">Link</label>
                <input
                    type="text"
                    className="form-control folder-textbox"
                    placeholder='Enter Name'
                    value={linkvalue}
                    onChange={handleLinkChange}
                />
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeCallback}
                >
                    Cancel
                </button>
                <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                    Edit
                </button>
            </ModalFooter>
        </Modal>);
};
export default EditLink;